import { E_Region } from '../../apis/service/types';
import { BASE_Features, CN_Features, US_Features, EU_Features, } from './features';
const FeatureMap = {
    [E_Region.CN]: CN_Features,
    [E_Region.US]: US_Features,
    [E_Region.EU]: EU_Features,
    Default: BASE_Features,
};
export default {
    namespaced: true,
    state: {
        region: 'Default',
    },
    getters: {
        Features(state) {
            return FeatureMap[state.region] || FeatureMap.Default;
        },
    },
    mutations: {
        setRegion(state, region) {
            state.region = region;
        },
    },
};
